function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPuzzle = function SvgPuzzle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8190_11904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1495 44 44 34.1495 44 22C44 9.8505 34.1495 0 22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44Z",
    fill: "#EAEAEA",
    style: _defineProperty(_defineProperty({
      fill: "#EAEAEA"
    }, "fill", "color(display-p3 0.9188 0.9188 0.9188)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1495 44 44 34.1495 44 22C44 9.8505 34.1495 0 22 0C9.8505 0 0 9.8505 0 22C0 34.1495 9.8505 44 22 44Z",
    fill: "#EAEAEA",
    style: _defineProperty(_defineProperty({
      fill: "#EAEAEA"
    }, "fill", "color(display-p3 0.9188 0.9188 0.9188)"), "fillOpacity", 1)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6159 26.2622L38.2694 17.0992C38.2309 16.0102 37.3014 15.1522 36.2124 15.1907L27.0494 15.5372C25.9604 15.5812 25.1024 16.5052 25.1409 17.5942L25.2784 21.2462L26.0319 21.2187C26.3619 20.3607 27.1759 19.7392 28.1494 19.7062C29.4529 19.6567 30.5474 20.6742 30.5969 21.9777C30.6464 23.2812 29.6289 24.3757 28.3254 24.4252C27.3519 24.4637 26.4939 23.9027 26.1034 23.0722L25.3499 23.0997L25.4874 26.7517C25.5259 27.8407 26.4554 28.6987 27.5444 28.6602L36.7074 28.3137C37.7964 28.2752 38.6544 27.3457 38.6159 26.2567",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5613 19.8936C21.6483 19.6186 20.6968 19.9376 20.1248 20.6251L19.7233 20.5041L20.7188 17.1931C21.0323 16.1481 20.4328 15.0371 19.3878 14.7236L10.6043 12.0891C9.55927 11.7756 8.44827 12.3751 8.13477 13.4201L5.50027 22.1981C5.18677 23.2431 5.78627 24.3541 6.83127 24.6676L15.6148 27.3021C16.6598 27.6156 17.7708 27.0161 18.0843 25.9711L19.2063 22.2421L19.6078 22.3631C19.7068 23.2541 20.3283 24.0461 21.2413 24.3156C22.4623 24.6841 23.7493 23.9911 24.1178 22.7646C24.4863 21.5436 23.7933 20.2511 22.5668 19.8881L22.5613 19.8936Z",
    fill: "#EA4403",
    style: _defineProperty(_defineProperty({
      fill: "#EA4403"
    }, "fill", "color(display-p3 0.9176 0.2667 0.0118)"), "fillOpacity", 1)
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8190_11904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPuzzle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/puzzle.9e0302c9ba8a5736d5e89ddea47412d4.svg";